/**
 * @function getOffset
 * @desc returns top left position of element
 * relative to the document.
 * @see [Stack Overflow](http://stackoverflow.com/questions/5598743/finding-elements-position-relative-to-the-document#answer-26230989)
 *
 * @param {HTMLElement} el - element you want position of;
 * @returns {Object} position - object with top and left position;
 */

export default <T extends HTMLElement = HTMLElement>(
  el?: T | null
): { top: number; left: number } | null => {
  if (el !== null && el !== undefined) {
    const box = el.getBoundingClientRect();

    const body = document.body;
    const docEl = document.documentElement;
    const pageYOffset: number = window.pageYOffset;
    const pageXOffset: number = window.pageXOffset;

    let scrollTop = Number(body.scrollTop);
    if (pageYOffset > 0) {
      scrollTop = pageYOffset;
    } else if (docEl.scrollTop > 0) {
      scrollTop = docEl.scrollTop;
    }
    let scrollLeft = Number(body.scrollLeft);
    if (pageXOffset > 0) {
      scrollLeft = pageXOffset;
    } else if (docEl.scrollLeft > 0) {
      scrollLeft = docEl.scrollLeft;
    }

    let clientTop = 0;
    if (docEl.clientTop > 0) {
      clientTop = docEl.clientTop;
    } else if (body.clientTop > 0) {
      clientTop = body.clientTop;
    }
    let clientLeft = 0;
    if (docEl.clientLeft > 0) {
      clientLeft = docEl.clientLeft;
    } else if (body.clientLeft > 0) {
      clientLeft = body.clientLeft;
    }

    const top = box.top + (scrollTop - clientTop);
    const left = box.left + (scrollLeft - clientLeft);

    return { top: Math.round(top), left: Math.round(left) };
  }

  return null;
};

// export default getOffset;
